
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as carto17Hk3H3NYEO_45FFdaJOjgwf0g_fC_a17YdUdJaFSiRYMeta } from "/vercel/path0/pages/cart.vue?macro=true";
import { default as rootxi_V0VKMSvumluePtkK3xiNfxdhVl8gKUmgLTqY_PswMeta } from "/vercel/path0/pages/root.vue?macro=true";
import { default as signNr2q8fMxtzMJua_45_45YrUquBpp_45pckM353AoLGl0Gp1EAMeta } from "/vercel/path0/pages/sign.vue?macro=true";
import { default as embedMC7_459ahdYFsMD3_MCCIvqEeopeZ_45SqytHisU9FkRZt4Meta } from "/vercel/path0/pages/embed.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as reset6IJHcGG6Kd_n_Dz3NZgYAyiriokyXAAhpvQ2_ZwOX3gMeta } from "/vercel/path0/pages/reset.vue?macro=true";
import { default as termsrbl0AisEJEK94jgNDoimMHDtED_45cqOs4QSX5phnU96AMeta } from "/vercel/path0/pages/terms.vue?macro=true";
import { default as signupB4YSZRkNKB9FDeS0v8yAB_45DoR_piC_5XlQOStR63J_45MMeta } from "/vercel/path0/pages/signup.vue?macro=true";
import { default as verify_45Vgs1Kdj9XmEYehgpaShkEDDzpbU_45anBvkypZK98cZ4Meta } from "/vercel/path0/pages/verify.vue?macro=true";
import { default as auctionVI_45wtB_LI3K6HfmMczbgvShPNuL0yS2eZqtDBB9t4scMeta } from "/vercel/path0/pages/auction.vue?macro=true";
import { default as privacyoUxJze_459YVMN19fHCMNcOPA4bNg1TjmwARd6j9aojjEMeta } from "/vercel/path0/pages/privacy.vue?macro=true";
import { default as _91_46_46_46all_93DcA_RHQVlPJpKWiD__KZ_458Qes8AMu1_45XSqY1n2_B_45s4Meta } from "/vercel/path0/pages/[...all].vue?macro=true";
import { default as djImTgtyQFtwRgvq8LX8Mj8JCKTbmeKkyYkRkB2rPb4qAMeta } from "/vercel/path0/pages/admin/dj.vue?macro=true";
import { default as index8TnTrG1RLdezOSU25M4mZcfRoygosPx29K_45pj23ghrsMeta } from "/vercel/path0/pages/about/index.vue?macro=true";
import { default as index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta } from "/vercel/path0/pages/admin/index.vue?macro=true";
import { default as teams_3w2SdBgBXNEmerKWj3gUClZEQ2vIZsWdBF3Yw32nlYMeta } from "/vercel/path0/pages/admin/teams.vue?macro=true";
import { default as sentCPvXqe9S_457A6qnFjUoNDF2K1T_aV5oR3hdPyDJ1DPUQMeta } from "/vercel/path0/pages/forgot/sent.vue?macro=true";
import { default as indexGPoTs_45GxCVlg4c9TMDL2ZpPp5OETBKUmgtMYyKKwM20Meta } from "/vercel/path0/pages/rules/index.vue?macro=true";
import { default as guestsQ_Yd4FD5q9OoThW2x_KRRg68db_yyZbKLVng_EcCiaoMeta } from "/vercel/path0/pages/admin/guests.vue?macro=true";
import { default as judgesHkv2lIr09vkyo050_45k6yF6gUjd8mIaxUvScnPEBTOKoMeta } from "/vercel/path0/pages/admin/judges.vue?macro=true";
import { default as photosU4TP7_ShTx9csJ4vbDnbCw_45RpcVJV2dz6zdrH7TxX2MMeta } from "/vercel/path0/pages/admin/photos.vue?macro=true";
import { default as scores1lnjVnoKeyfAXJ02nR3P6nPlxnLRZFws_4jw37kj84gMeta } from "/vercel/path0/pages/admin/scores.vue?macro=true";
import { default as index2BaEeC6kYWO0NoxsxoO7Qvkra_IYhSAyPVURrbLDtucMeta } from "/vercel/path0/pages/causes/index.vue?macro=true";
import { default as index9sCfo_4520SBRD6kJbq20eyQkOu_45H2iyqCisWMyScHFIEMeta } from "/vercel/path0/pages/donate/index.vue?macro=true";
import { default as indexmFhQLiP7v4K_AreQtD46PkcDA_kn33M_a7aEqVVwvx4Meta } from "/vercel/path0/pages/forgot/index.vue?macro=true";
import { default as indexEBlNOVV2hJeBf5Qi0vvxoSPuSbI_45wdFMPaYsbzelMnoMeta } from "/vercel/path0/pages/judges/index.vue?macro=true";
import { default as backKgREZtsFMH5NkAUiSasf2iE5UYUWFgoXVkUa7Ic8lW0Meta } from "/vercel/path0/pages/welcome/back.vue?macro=true";
import { default as teamkdkx2_NVnLhpy6ktDeCGmuzdTjnPGDc_45VcLXuEnEbCUMeta } from "/vercel/path0/pages/welcome/team.vue?macro=true";
import { default as anglersWqweOS2mrLjr_4539UCnEykq2b95p_45X2Yi4itgbe38tNoMeta } from "/vercel/path0/pages/admin/anglers.vue?macro=true";
import { default as auctiongPKrFUfsSPJtJLVbaiNBOyJ3Q3M1_CnBjRUPX6zCebwMeta } from "/vercel/path0/pages/admin/auction.vue?macro=true";
import { default as invitesVWn0_45Dx7xzEIJAgjOLE_l18ilgkJZhM1DCLm3IBmYPkMeta } from "/vercel/path0/pages/admin/invites.vue?macro=true";
import { default as pendingi4E0Rc8ncVXVdWFYw_wrZZBRefZFQwalm26Uxets88cMeta } from "/vercel/path0/pages/admin/pending.vue?macro=true";
import { default as raffles4HnslCGquOxF1wzLEWLGxhuCzzNove8J081h4pl2PpcMeta } from "/vercel/path0/pages/admin/raffles.vue?macro=true";
import { default as indexZm1iNQhmpJ_edh9dbuS5a5Utxa2EOmKpHUvGLH1YhEoMeta } from "/vercel/path0/pages/honoree/index.vue?macro=true";
import { default as guests5_rDSUnRbVmg4tLJvey74GQbWAD1qCN_4502OFFAiBdWUMeta } from "/vercel/path0/pages/judges/guests.vue?macro=true";
import { default as index4S4MOlo6r0z9nQXe5W59mZAWiJGxqvEY1H8Np46L8T4Meta } from "/vercel/path0/pages/my-team/index.vue?macro=true";
import { default as index_452XdQ5ST9vP51dTAzv3pjoAhuRTz6TXUr3bZwmQuLCEMeta } from "/vercel/path0/pages/raffles/index.vue?macro=true";
import { default as indexbqJ3OTpyX_hQLPuGnkKUvbhYBpmSoR1DlPFd9HrChboMeta } from "/vercel/path0/pages/welcome/index.vue?macro=true";
import { default as paymentsbwmO9yrEp_45Am0kbi2nyzvHEPe_j6QCJjkIWVXT_45d0YYMeta } from "/vercel/path0/pages/admin/payments.vue?macro=true";
import { default as settingsrEEwqQknB0kDnK92VWs7YTgTXXKs4V2854jh0YtU6kQMeta } from "/vercel/path0/pages/admin/settings.vue?macro=true";
import { default as waitlist2R9do1ZYCdNeZ2mv6Ks7eH2OaF9ZUjTILS3fp8cPLwAMeta } from "/vercel/path0/pages/admin/waitlist.vue?macro=true";
import { default as indexhOyQI6OkSESyTPWMDGuvvZLlogXkTCCKmeMYvryFcLkMeta } from "/vercel/path0/pages/checkout/index.vue?macro=true";
import { default as _91token_93a26tgivkt2xwhxnEsLdJIDaYUUW5OPmLl0pEAQSoPigMeta } from "/vercel/path0/pages/invite/[token].vue?macro=true";
import { default as anglersSCzoL8xr7PXls_JjH_ytFuplmPWIJozmLkuVWKM9hJ8Meta } from "/vercel/path0/pages/judges/anglers.vue?macro=true";
import { default as rafflesyyW5r6goMZeyMF9ApJ20FxzP4wiszarTv7_453k_45nS_45msMeta } from "/vercel/path0/pages/judges/raffles.vue?macro=true";
import { default as scoringSaS2omDcIi7FKAWDxOGcC_45gIOQVvoPVn6bfCA_vMATwMeta } from "/vercel/path0/pages/judges/scoring.vue?macro=true";
import { default as indexJkXatsN9bC8EwFOsaSWUrGfMwkp9RONgwkqJmYeXH8wMeta } from "/vercel/path0/pages/schedule/index.vue?macro=true";
import { default as dashboardJLgY_45pk63kzMCm9yuqJ3BxnQlJZRCEqjWncRiulWHP8Meta } from "/vercel/path0/pages/admin/dashboard.vue?macro=true";
import { default as indexcgj1YhTOlUth3jdoUCCx0gwsOKYltazOce0k7q7mnxcMeta } from "/vercel/path0/pages/dashboard/index.vue?macro=true";
import { default as indexdgC_3UQazJa_45SGHADh4uYCATr1_45BbozYaXz_gflOU2UMeta } from "/vercel/path0/pages/thank-you/index.vue?macro=true";
import { default as sponsoriFJNg9VQsDTi8_45wHf4Ui_45Ks6XfPIqjVWrDmycZRnL_45oMeta } from "/vercel/path0/pages/welcome/sponsor.vue?macro=true";
import { default as checkout_confirm3Ltz_meORaBzuE_u31TZ_l_459TfZ1Jt8aGyIUlY5AdcQMeta } from "/vercel/path0/pages/checkout_confirm.vue?macro=true";
import { default as paymentomc2qaX3i2zqkY3_45_45r5fSFDl5YFROALdlRdDPS2_t60Meta } from "/vercel/path0/pages/checkout/payment.vue?macro=true";
import { default as backSovkxPkGNcVdw_45ioPvdWNRIejBdIi0JBkN1xTphB0vMMeta } from "/vercel/path0/pages/new-welcome/back.vue?macro=true";
import { default as teamKNwQ8vPdAYNg5LzpfZHGMdb58Zb9qn8OjyrJiX5yH74Meta } from "/vercel/path0/pages/new-welcome/team.vue?macro=true";
import { default as mapKWVpwCTne8QpfKhvtBtQyMPlbPVfpmunXE49z4TTG9cMeta } from "/vercel/path0/pages/public/rules/map.vue?macro=true";
import { default as index433JHtLOARBMZUn7JfirEzKCR_LzMijt0nMSjudEDYkMeta } from "/vercel/path0/pages/testMember/index.vue?macro=true";
import { default as leaderboard_PJP_X6TEUFzsp2Nx55F8QzMQp1IU1sWMGR6fraJhHYMeta } from "/vercel/path0/pages/admin/leaderboard.vue?macro=true";
import { default as indexFlJr2vwADWPUhCuDJ_nPR0yktzoU9_45h_aKGSRtyOuHAMeta } from "/vercel/path0/pages/leaderboard/index.vue?macro=true";
import { default as indexcdx4j24T2CYoDMMFMkadyB3M7TI4FNxOCvWStvCSDesMeta } from "/vercel/path0/pages/new-welcome/index.vue?macro=true";
import { default as _91id_932Jy6e8uhR7FLzsxKlML_45QuPslZUhLKSyyVU_z2DM1N8Meta } from "/vercel/path0/pages/public/raffle/[id].vue?macro=true";
import { default as indexoKMZeER54umVY9hdQvkSPzacE8cFedbADJVR6NkyXckMeta } from "/vercel/path0/pages/public/rules/index.vue?macro=true";
import { default as announcementsQtYJ64TsI38OBRPoB1HFYkcii4E6O6IgRjDOxNEDSjYMeta } from "/vercel/path0/pages/admin/announcements.vue?macro=true";
import { default as raffles_45tablekUoC0AOComJf69JvUo4fF5m01ZcMOmGGAyE8fzclH9UMeta } from "/vercel/path0/pages/admin/raffles-table.vue?macro=true";
import { default as indexx3xJwdr_3Qg5D7WxtBMpCRTl2AJx2G6GMVEu1dMe3jUMeta } from "/vercel/path0/pages/announcements/index.vue?macro=true";
import { default as _91id_93EjX0_45crL8w77P8Z4fvzbFt1iwNWw0GYYsfA5O0Y3GwoMeta } from "/vercel/path0/pages/public/auction/[id].vue?macro=true";
import { default as random_45winnerscPe_vpJw9Z3xO_zgRSS1y5VXfpOxmT1k__45JWBsG5bEUMeta } from "/vercel/path0/pages/admin/random-winners.vue?macro=true";
import { default as _91token_93AibhLUZDS4vKBqer3FdTane_x_456m0UZwLiLh8K7KtzAMeta } from "/vercel/path0/pages/invite/judge/[token].vue?macro=true";
import { default as _91token_93mE6jFIfq3NY8bJlipuyT8ywnA57Du3xUdWQeovEGDiIMeta } from "/vercel/path0/pages/invite/leader/[token].vue?macro=true";
import { default as _91token_93qeqnoR4WJPqS0nVoF6Zy45vYwYmDt_nSVi1eEGxCMHoMeta } from "/vercel/path0/pages/invite/member/[token].vue?macro=true";
import { default as industry_45vendorf3uqUdOkjd8fC_45untpm3OwdXuJBZGhYfaZQ42QAjDFsMeta } from "/vercel/path0/pages/welcome/industry-vendor.vue?macro=true";
import { default as industry_45vendortFfXC9NbDDU7o9FiGtkZ7YxYNVFWSixw_45k78KCgcGtgMeta } from "/vercel/path0/pages/new-welcome/industry-vendor.vue?macro=true";
export default [
  {
    name: "cart",
    path: "/cart",
    meta: {"middleware":["sponsor-only"]},
    component: () => import("/vercel/path0/pages/cart.vue")
  },
  {
    name: "root",
    path: "/root",
    meta: { ...(rootxi_V0VKMSvumluePtkK3xiNfxdhVl8gKUmgLTqY_PswMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/root.vue")
  },
  {
    name: "sign",
    path: "/sign",
    component: () => import("/vercel/path0/pages/sign.vue")
  },
  {
    name: "embed",
    path: "/embed",
    component: () => import("/vercel/path0/pages/embed.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"middleware":["not-user-only"]},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "reset",
    path: "/reset",
    meta: {"middleware":["not-user-only"]},
    component: () => import("/vercel/path0/pages/reset.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/vercel/path0/pages/terms.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: {"middleware":["not-user-only"]},
    component: () => import("/vercel/path0/pages/signup.vue")
  },
  {
    name: "verify",
    path: "/verify",
    component: () => import("/vercel/path0/pages/verify.vue")
  },
  {
    name: "auction",
    path: "/auction",
    meta: auctionVI_45wtB_LI3K6HfmMczbgvShPNuL0yS2eZqtDBB9t4scMeta || {},
    component: () => import("/vercel/path0/pages/auction.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/vercel/path0/pages/privacy.vue")
  },
  {
    name: "all",
    path: "/:all(.*)*",
    component: () => import("/vercel/path0/pages/[...all].vue")
  },
  {
    name: "admin-dj",
    path: "/admin/dj",
    component: () => import("/vercel/path0/pages/admin/dj.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/pages/about/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/index.vue")
  },
  {
    name: "admin-teams",
    path: "/admin/teams",
    meta: { ...(teams_3w2SdBgBXNEmerKWj3gUClZEQ2vIZsWdBF3Yw32nlYMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/teams.vue")
  },
  {
    name: "forgot-sent",
    path: "/forgot/sent",
    meta: {"middleware":["not-user-only"]},
    component: () => import("/vercel/path0/pages/forgot/sent.vue")
  },
  {
    name: "rules",
    path: "/rules",
    meta: { ...(indexGPoTs_45GxCVlg4c9TMDL2ZpPp5OETBKUmgtMYyKKwM20Meta || {}), ...{"middleware":["dashboard"]} },
    component: () => import("/vercel/path0/pages/rules/index.vue")
  },
  {
    name: "admin-guests",
    path: "/admin/guests",
    meta: { ...(guestsQ_Yd4FD5q9OoThW2x_KRRg68db_yyZbKLVng_EcCiaoMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/guests.vue")
  },
  {
    name: "admin-judges",
    path: "/admin/judges",
    meta: { ...(judgesHkv2lIr09vkyo050_45k6yF6gUjd8mIaxUvScnPEBTOKoMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/judges.vue")
  },
  {
    name: "admin-photos",
    path: "/admin/photos",
    meta: photosU4TP7_ShTx9csJ4vbDnbCw_45RpcVJV2dz6zdrH7TxX2MMeta || {},
    component: () => import("/vercel/path0/pages/admin/photos.vue")
  },
  {
    name: "admin-scores",
    path: "/admin/scores",
    meta: { ...(scores1lnjVnoKeyfAXJ02nR3P6nPlxnLRZFws_4jw37kj84gMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/scores.vue")
  },
  {
    name: "causes",
    path: "/causes",
    meta: index2BaEeC6kYWO0NoxsxoO7Qvkra_IYhSAyPVURrbLDtucMeta || {},
    component: () => import("/vercel/path0/pages/causes/index.vue")
  },
  {
    name: "donate",
    path: "/donate",
    meta: index9sCfo_4520SBRD6kJbq20eyQkOu_45H2iyqCisWMyScHFIEMeta || {},
    component: () => import("/vercel/path0/pages/donate/index.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    component: () => import("/vercel/path0/pages/forgot/index.vue")
  },
  {
    name: "judges",
    path: "/judges",
    meta: { ...(indexEBlNOVV2hJeBf5Qi0vvxoSPuSbI_45wdFMPaYsbzelMnoMeta || {}), ...{"middleware":["judge-only"]} },
    component: () => import("/vercel/path0/pages/judges/index.vue")
  },
  {
    name: "welcome-back",
    path: "/welcome/back",
    meta: {"middleware":["welcome-back"]},
    component: () => import("/vercel/path0/pages/welcome/back.vue")
  },
  {
    name: "welcome-team",
    path: "/welcome/team",
    component: () => import("/vercel/path0/pages/welcome/team.vue")
  },
  {
    name: "admin-anglers",
    path: "/admin/anglers",
    meta: { ...(anglersWqweOS2mrLjr_4539UCnEykq2b95p_45X2Yi4itgbe38tNoMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/anglers.vue")
  },
  {
    name: "admin-auction",
    path: "/admin/auction",
    meta: { ...(auctiongPKrFUfsSPJtJLVbaiNBOyJ3Q3M1_CnBjRUPX6zCebwMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/auction.vue")
  },
  {
    name: "admin-invites",
    path: "/admin/invites",
    meta: { ...(invitesVWn0_45Dx7xzEIJAgjOLE_l18ilgkJZhM1DCLm3IBmYPkMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/invites.vue")
  },
  {
    name: "admin-pending",
    path: "/admin/pending",
    meta: { ...(pendingi4E0Rc8ncVXVdWFYw_wrZZBRefZFQwalm26Uxets88cMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/pending.vue")
  },
  {
    name: "admin-raffles",
    path: "/admin/raffles",
    meta: { ...(raffles4HnslCGquOxF1wzLEWLGxhuCzzNove8J081h4pl2PpcMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/raffles.vue")
  },
  {
    name: "honoree",
    path: "/honoree",
    meta: indexZm1iNQhmpJ_edh9dbuS5a5Utxa2EOmKpHUvGLH1YhEoMeta || {},
    component: () => import("/vercel/path0/pages/honoree/index.vue")
  },
  {
    name: "judges-guests",
    path: "/judges/guests",
    meta: { ...(guests5_rDSUnRbVmg4tLJvey74GQbWAD1qCN_4502OFFAiBdWUMeta || {}), ...{"middleware":["judge-only"]} },
    component: () => import("/vercel/path0/pages/judges/guests.vue")
  },
  {
    name: "my-team",
    path: "/my-team",
    meta: { ...(index4S4MOlo6r0z9nQXe5W59mZAWiJGxqvEY1H8Np46L8T4Meta || {}), ...{"middleware":["dashboard"]} },
    component: () => import("/vercel/path0/pages/my-team/index.vue")
  },
  {
    name: "raffles",
    path: "/raffles",
    meta: index_452XdQ5ST9vP51dTAzv3pjoAhuRTz6TXUr3bZwmQuLCEMeta || {},
    component: () => import("/vercel/path0/pages/raffles/index.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: {"middleware":["sponsor-only"]},
    component: () => import("/vercel/path0/pages/welcome/index.vue")
  },
  {
    name: "admin-payments",
    path: "/admin/payments",
    meta: { ...(paymentsbwmO9yrEp_45Am0kbi2nyzvHEPe_j6QCJjkIWVXT_45d0YYMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/payments.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    meta: { ...(settingsrEEwqQknB0kDnK92VWs7YTgTXXKs4V2854jh0YtU6kQMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/settings.vue")
  },
  {
    name: "admin-waitlist",
    path: "/admin/waitlist",
    meta: { ...(waitlist2R9do1ZYCdNeZ2mv6Ks7eH2OaF9ZUjTILS3fp8cPLwAMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/waitlist.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: {"middleware":["sponsor-only"]},
    component: () => import("/vercel/path0/pages/checkout/index.vue")
  },
  {
    name: "invite-token",
    path: "/invite/:token()",
    meta: { ...(_91token_93a26tgivkt2xwhxnEsLdJIDaYUUW5OPmLl0pEAQSoPigMeta || {}), ...{"middleware":["not-user-only"]} },
    component: () => import("/vercel/path0/pages/invite/[token].vue")
  },
  {
    name: "judges-anglers",
    path: "/judges/anglers",
    meta: { ...(anglersSCzoL8xr7PXls_JjH_ytFuplmPWIJozmLkuVWKM9hJ8Meta || {}), ...{"middleware":["judge-only"]} },
    component: () => import("/vercel/path0/pages/judges/anglers.vue")
  },
  {
    name: "judges-raffles",
    path: "/judges/raffles",
    meta: rafflesyyW5r6goMZeyMF9ApJ20FxzP4wiszarTv7_453k_45nS_45msMeta || {},
    component: () => import("/vercel/path0/pages/judges/raffles.vue")
  },
  {
    name: "judges-scoring",
    path: "/judges/scoring",
    meta: { ...(scoringSaS2omDcIi7FKAWDxOGcC_45gIOQVvoPVn6bfCA_vMATwMeta || {}), ...{"middleware":["judge-only"]} },
    component: () => import("/vercel/path0/pages/judges/scoring.vue")
  },
  {
    name: "schedule",
    path: "/schedule",
    meta: { ...(indexJkXatsN9bC8EwFOsaSWUrGfMwkp9RONgwkqJmYeXH8wMeta || {}), ...{"middleware":["dashboard"]} },
    component: () => import("/vercel/path0/pages/schedule/index.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    meta: { ...(dashboardJLgY_45pk63kzMCm9yuqJ3BxnQlJZRCEqjWncRiulWHP8Meta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/dashboard.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(indexcgj1YhTOlUth3jdoUCCx0gwsOKYltazOce0k7q7mnxcMeta || {}), ...{"middleware":["dashboard"]} },
    component: () => import("/vercel/path0/pages/dashboard/index.vue")
  },
  {
    name: "thank-you",
    path: "/thank-you",
    meta: indexdgC_3UQazJa_45SGHADh4uYCATr1_45BbozYaXz_gflOU2UMeta || {},
    component: () => import("/vercel/path0/pages/thank-you/index.vue")
  },
  {
    name: "welcome-sponsor",
    path: "/welcome/sponsor",
    component: () => import("/vercel/path0/pages/welcome/sponsor.vue")
  },
  {
    name: "checkout_confirm",
    path: "/checkout_confirm",
    component: () => import("/vercel/path0/pages/checkout_confirm.vue")
  },
  {
    name: "checkout-payment",
    path: "/checkout/payment",
    component: () => import("/vercel/path0/pages/checkout/payment.vue")
  },
  {
    name: "new-welcome-back",
    path: "/new-welcome/back",
    meta: {"middleware":["welcome-back"]},
    component: () => import("/vercel/path0/pages/new-welcome/back.vue")
  },
  {
    name: "new-welcome-team",
    path: "/new-welcome/team",
    component: () => import("/vercel/path0/pages/new-welcome/team.vue")
  },
  {
    name: "public-rules-map",
    path: "/public/rules/map",
    meta: mapKWVpwCTne8QpfKhvtBtQyMPlbPVfpmunXE49z4TTG9cMeta || {},
    component: () => import("/vercel/path0/pages/public/rules/map.vue")
  },
  {
    name: "testMember",
    path: "/testMember",
    meta: { ...(index433JHtLOARBMZUn7JfirEzKCR_LzMijt0nMSjudEDYkMeta || {}), ...{"middleware":["dashboard"]} },
    component: () => import("/vercel/path0/pages/testMember/index.vue")
  },
  {
    name: "admin-leaderboard",
    path: "/admin/leaderboard",
    meta: leaderboard_PJP_X6TEUFzsp2Nx55F8QzMQp1IU1sWMGR6fraJhHYMeta || {},
    component: () => import("/vercel/path0/pages/admin/leaderboard.vue")
  },
  {
    name: "leaderboard",
    path: "/leaderboard",
    meta: { ...(indexFlJr2vwADWPUhCuDJ_nPR0yktzoU9_45h_aKGSRtyOuHAMeta || {}), ...{"middleware":["dashboard"]} },
    component: () => import("/vercel/path0/pages/leaderboard/index.vue")
  },
  {
    name: "new-welcome",
    path: "/new-welcome",
    meta: {"middleware":["sponsor-only"]},
    component: () => import("/vercel/path0/pages/new-welcome/index.vue")
  },
  {
    name: "public-raffle-id",
    path: "/public/raffle/:id()",
    meta: _91id_932Jy6e8uhR7FLzsxKlML_45QuPslZUhLKSyyVU_z2DM1N8Meta || {},
    component: () => import("/vercel/path0/pages/public/raffle/[id].vue")
  },
  {
    name: "public-rules",
    path: "/public/rules",
    meta: indexoKMZeER54umVY9hdQvkSPzacE8cFedbADJVR6NkyXckMeta || {},
    component: () => import("/vercel/path0/pages/public/rules/index.vue")
  },
  {
    name: "admin-announcements",
    path: "/admin/announcements",
    meta: { ...(announcementsQtYJ64TsI38OBRPoB1HFYkcii4E6O6IgRjDOxNEDSjYMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/announcements.vue")
  },
  {
    name: "admin-raffles-table",
    path: "/admin/raffles-table",
    meta: { ...(raffles_45tablekUoC0AOComJf69JvUo4fF5m01ZcMOmGGAyE8fzclH9UMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/raffles-table.vue")
  },
  {
    name: "announcements",
    path: "/announcements",
    meta: { ...(indexx3xJwdr_3Qg5D7WxtBMpCRTl2AJx2G6GMVEu1dMe3jUMeta || {}), ...{"middleware":["dashboard"]} },
    component: () => import("/vercel/path0/pages/announcements/index.vue")
  },
  {
    name: "public-auction-id",
    path: "/public/auction/:id()",
    meta: _91id_93EjX0_45crL8w77P8Z4fvzbFt1iwNWw0GYYsfA5O0Y3GwoMeta || {},
    component: () => import("/vercel/path0/pages/public/auction/[id].vue")
  },
  {
    name: "admin-random-winners",
    path: "/admin/random-winners",
    meta: { ...(random_45winnerscPe_vpJw9Z3xO_zgRSS1y5VXfpOxmT1k__45JWBsG5bEUMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/vercel/path0/pages/admin/random-winners.vue")
  },
  {
    name: "invite-judge-token",
    path: "/invite/judge/:token()",
    meta: { ...(_91token_93AibhLUZDS4vKBqer3FdTane_x_456m0UZwLiLh8K7KtzAMeta || {}), ...{"middleware":["not-user-only"]} },
    component: () => import("/vercel/path0/pages/invite/judge/[token].vue")
  },
  {
    name: "invite-leader-token",
    path: "/invite/leader/:token()",
    meta: { ...(_91token_93mE6jFIfq3NY8bJlipuyT8ywnA57Du3xUdWQeovEGDiIMeta || {}), ...{"middleware":["not-user-only"]} },
    component: () => import("/vercel/path0/pages/invite/leader/[token].vue")
  },
  {
    name: "invite-member-token",
    path: "/invite/member/:token()",
    meta: { ...(_91token_93qeqnoR4WJPqS0nVoF6Zy45vYwYmDt_nSVi1eEGxCMHoMeta || {}), ...{"middleware":["not-user-only"]} },
    component: () => import("/vercel/path0/pages/invite/member/[token].vue")
  },
  {
    name: "welcome-industry-vendor",
    path: "/welcome/industry-vendor",
    meta: {"middleware":["sponsor-only"]},
    component: () => import("/vercel/path0/pages/welcome/industry-vendor.vue")
  },
  {
    name: "new-welcome-industry-vendor",
    path: "/new-welcome/industry-vendor",
    meta: {"middleware":["sponsor-only"]},
    component: () => import("/vercel/path0/pages/new-welcome/industry-vendor.vue")
  }
]